module.exports = {
  '菜单': '菜单',
  '首页': '首页',
  '贡献': '贡献',
  '理财': '理财',
  '资产': '资产',
  '我的社群': '我的社群',
  '分红节点': '分红节点',
  '邀请好友': '邀请好友',
  '制度说明': '制度说明',
  '复制成功': '复制成功',
  '复制失败': '复制失败',
  '公告列表': '公告列表',
  '公告详情': '公告详情',
  '没有更多了': '没有更多了',
  '流通量': '流通量',
  '总发行量': '总发行量',
  '低池U量': '底池U量',
  '低池ACT量': '底池ACT量',
  '当前分红节点：': '当前分红节点：',
  'ACT币趋势': 'ACT币趋势',
  '当前价格': '当前价格',
  '选择支付方式': '选择支付方式',
  '我的贡献': '我的贡献',
  '确定': '确定',
  '应支付': '应支付',
  '请输入贡献数量': '请输入贡献数量',
  '请输入交易密码': '请输入交易密码',
  '贡献数量': '贡献数量',
  '交易密码': '交易密码',
  '复投': '复投',
  '复投成功': '复投成功',
  'USDT+卡牌': 'USDT+卡牌',
  'ACT+卡牌': 'ACT+卡牌',
  '可用': '可用',
  '请输入数量': '请输入数量',
  '请输入复投数量': '请输入复投数量',
  '请勿重复提交': '请勿重复提交',
  '我的理财': '我的理财',
  '参与理财': '参与理财',
  '价格': '价格',
  '收益率': '收益率',
  '天': '天',
  '到账地址': '到账地址',
  '理财收益率': '理财收益率',
  '理财金额': '理财金额',
  '周期': '周期',
  '到期': '到期',
  '当期收益': '当期收益',
  '已结束': '已结束',
  '理财中': '理财中',
  '参与成功': '参与成功',
  '卡牌': '卡牌',
  '互转': '互转',
  '闪兑': '闪兑',
  '提现': '提现',
  '互转记录': '互转记录',
  '闪兑记录': '闪兑记录',
  '提现记录': '提现记录',
  '手续费': '手续费',
  '提现地址': '提现地址',
  '兑换方式': '兑换方式',
  '转账地址': '转账地址',
  '时间': '时间',
  'ACT兑卡牌': 'ACT兑卡牌',
  'ACT兑USDT': 'ACT兑USDT',
  'USDT兑ACT': 'USDT兑ACT',
  '钱包': '钱包',
  '操作时间': '操作时间',
  '流水明细': '流水明细',
  '请输入接收地址': '请输入接收地址',
  '请输入互转数量': '请输入互转数量',
  '互转数量': '互转数量',
  '互转说明': '互转说明',
  '接收地址': '接收地址',
  '实际到账': '实际到账',
  '互转成功': '互转成功',
  '自动计算': '自动计算',
  '闪兑说明': '闪兑说明',
  '实际销毁': '实际销毁',
  '闪兑数量': '闪兑数量',
  '闪兑币种': '闪兑币种',
  '请输入闪兑数量': '请输入闪兑数量',
  '操作成功': '操作成功',
  '提现数量': '提现数量',
  '最小提现数量': '最小提现数量',
  '请输入提现地址': '请输入提现地址',
  '提现说明': '提现说明',
  '请输入提现数量': '请输入提现数量',
  '账号': '账号',
  '贡献值': '贡献值',
  '我的推荐': '我的推荐',
  '节点团队业绩': '节点团队业绩',
  '理财团队一月内业绩': '理财团队一月内业绩',
  '理财团队一月以上业绩': '理财团队一月以上业绩',
  '直推人数': '直推人数',
  '级别': '级别',
  '分红点': '分红点',
  '团队人数': '团队人数',
  '我的贡献': '我的贡献',
  '权益值': '权益值',
  '推广链接': '推广链接',
  '当前系统分红节点': '当前系统分红节点',
  '我的节点': '我的节点',
  '节点记录': '节点记录',
  '节点数量': '节点数量',
  '节点排名': '节点排名',
  '名次': '名次',
  '数量': '数量',
  'DAB数量': 'DAB数量',
  '地址': '地址',
  '是否有效': '是否有效',
  '有效节点': '有效节点',
  '无效节点': '无效节点',
  '兑换时间': '兑换时间',
  '复制并保存': '复制并保存',
  '到期收益': '到期收益',
  '复制链接': '复制链接',
  '消耗数量': '消耗数量',
  '待审核': '待审核',
  '通过': '通过',
  '驳回': '驳回',
  '转账中': '转账中',
  '驳回原因': '驳回原因',
  '充值说明': '充值说明',
  '充值数量': '充值数量',
  '请输入充值数量': '请输入充值数量',
  '充值': '充值',
  '请确认新密码': '请确认新密码',
  '请输入新密码': '请输入新密码',
  '请输入旧密码': '请输入旧密码',
  '修改密码': '修改密码',
  '支付': '支付',
  '支付数量': '支付数量',
  '支付币种': '支付币种',
  '实际支付': '实际支付',
  '来源地址': '来源地址',
  '成功': '成功',
  '检测中': '检测中',
  '充值地址': '充值地址',
  '充值记录': '充值记录',
  '失败': '失败',
  '余额不足': '余额不足',

  "矿机": "矿机",
  "我的矿机": "我的矿机",
  "已购买矿机": "已购买矿机",
  "台": "台",
  "开始挖矿": "开始挖矿",
  "进度": "进度",
  "动态分红": "动态分红",
  "查看更多": "查看更多",
  "领导分红": "领导分红",
  "提示": "提示",
  "取消": "取消",
  "请先购买矿机": "请先购买矿机",
  "矿机商城": "矿机商城",
  "价值": "价值",
  "购买": "购买",
  "购买次数": "购买次数",
  "过期矿机": "过期矿机",
  "运行次数": "运行次数",
  "购买日期": "购买日期",
  "到期日期": "到期日期",
  "已过期": "已过期",
  "产出": "产出",
  "USDT兑ACTs": "USDT兑ACTs",
  "冻结": "冻结",
  "启动": "启动",
  "运行中": "运行中",
  "暂无收汇地址": "暂无收汇地址",
  "钱包提现": "钱包提现",
  "银行卡提现": "银行卡提现",
  "人民币": "人民币",
  "美金": "美金",
  "英镑": "英镑",
  "欧元": "欧元",
  "聊天": "聊天",
  "请先维护提现银行卡信息": "请先维护提现银行卡信息",
  "身份输入": "身份输入",
  "身份信息": "身份信息",
  "姓名": "姓名",
  "请输入姓名": "请输入姓名",
  "姓拼音": "姓拼音",
  "请输入姓拼音, 如`Zhang`": "请输入姓拼音, 如`Zhang`",
  "请输入姓拼音": "请输入姓拼音",
  "名拼音": "名拼音",
  "请输入名拼音, 如`San`": "请输入名拼音, 如`San`",
  "请输入名拼音": "请输入名拼音",
  "证件信息": "证件信息",
  "国籍": "国籍",
  "证件类型": "证件类型",
  "证件号": "证件号",
  "请输入证件号": "请输入证件号",
  "银行卡信息": "银行卡信息",
  "银行名称": "银行名称",
  "请输入银行名称": "请输入银行名称",
  "银行卡号": "银行卡号",
  "请输入银行卡号": "请输入银行卡号",
  "开户行": "开户行",
  "请输入开户行": "请输入开户行",
  "中华人民共和国": "中华人民共和国",
  "美国": "美国",
  "英国": "英国",
  "户口本": "户口本",
  "护照": "护照",
  "请上传银行卡照片（选填）": "请上传银行卡照片（选填）",
  "去添加": "去添加",
  "完善信息": "完善信息",
  "邀请人": "邀请人",
  "请输入邀请码": "请输入邀请码",
  "请输入6位纯数字": "请输入6位纯数字",
  "请复制聊天链接，在手机默认浏览器中打开使用！": "请复制聊天链接，在手机默认浏览器中打开使用！",
  "复制": "复制",
  "语音聊天": "语音聊天",
  "数量": "数量",
  "已收益": "已收益",
  "每日收益": "每日收益",
  "我的理财明细": "我的理财明细",
  "币种": "币种",
  "类型": "类型",
  "理财收益": "理财收益",
  "理财记录": "理财记录",
  "请切换币安链": "请切换币安链",
  "充值中，请不要返回！": "充值中，请不要返回！",
  "提现未开启": "提现未开启",

  "收货地址": "收货地址",
  "新增地址": "新增地址",
  "编辑": "编辑",
  "删除": "删除",
  "默认": "默认",
  "保存": "保存",
  "请输入收货人姓名": "请输入收货人姓名",
  "收货人": "收货人",
  "请输入收货人手机号": "请输入收货人手机号",
  "手机号": "手机号",
  "所在地区": "所在地区",
  "请选择地区": "请选择地区",
  "请输入详细地址：如道路、街道、楼号等": "提请输入详细地址：如道路、街道、楼号等",
  "设为默认收货地址": "设为默认收货地址",
  "编辑地址": "编辑地址",
  "确定要删除此地址吗?": "确定要删除此地址吗?",

  "修改地址成功": "修改地址成功",
  "添加地址成功": "添加地址成功",
  "删除成功": "删除成功成功",

  "提交订单": "提交订单",
  "提交": "提交",
  "暂无收汇地址": "暂无收汇地址",
  "品鉴商城": "品鉴商城",

  "快递公司": "快递公司",
  "快递单号": "快递单号",

  "我的订单": "我的订单",
  "我的收益": "我的收益",
  "过期收益": "过期收益",
  "选择这个地址": "选择这个地址",
  "请选择您的地区": "请选择您的地区",
  "支付失败": "支付失败",

  "请选择语言": "请选择语言",
  "行情": "行情",
  "我的团队": "我的团队",
  "交易规则": "交易规则",
  "关于我们": "关于我们",
  "公告中心": "公告中心",

  "今日分红": "今日分红",
  "算力值": "算力值",
  "投资数量": "投资数量",
  "投资倍数": "投资倍数",
  "兑换": "兑换",
  "用户": "用户",
  "金额": "金额",


  "我的钱包": "我的钱包",
  "请先从左上角连接钱包": "请先从左上角连接钱包",
  "确定要退出吗": "确定要退出吗",

  "我的钱包地址": "我的钱包地址",
  "上级钱包地址": "上级钱包地址",
  "累计收益": "累计收益",
  "我的算力": "我的算力",
  "总算力": "总算力",

  "可用数量": "可用数量",
  "提现范围": "提现范围",
  "提现时间": "提现时间",

  "成交量": "成交量",
  "矿工数": "矿工数",

  "请安装钱包插件": "请安装钱包插件",
  "请手动切换到币安链": "请手动切换到币安链",
  "用户取消连接": "用户取消连接",
  "签名被取消": "签名被取消",
  "登录失败": "确定要退出吗",

  "团队业绩": "团队业绩",
  "算力": "算力",
  "设置等级": "设置等级",

  "级别": "级别",
  "确定要设置级别吗": "确定要设置级别吗",

  "确定要设置等级吗": "确定要设置等级吗",
  "个人算力": "个人算力",

  '会员等级': '会员等级',
  '投资记录': '投资记录',
  '投资': '投资',
  '直推列表': '直推列表',
  '请输入账号': '请输入账号',
  '直推有效人数': '直推有效人数',
  '搜索': '搜索',
  '全网总算力': '全网总算力',
  '显示团队': '显示团队',
  '显示直推': '显示直推',
  '您要绑定的邀请码': '您要绑定的邀请码',
  '您需要有绑定的邀请码': '您需要有绑定的邀请码',
  '全部': '全部',


}